import React from "react";

import { random } from "@common";

export interface ITextAreaProps {
  readOnly: boolean;
  label: string;
  value: string;
}

const textarea = ({ readOnly, label, value }: ITextAreaProps) => {
  const id = random();
  return (
    <div
      style={{
        boxSizing: "border-box",
        marginBottom: "16px",
        fontSize: "12px",
        flexDirection: "column"
      }}
    >
      <label
        style={{
          boxSizing: "border-box",
          fontSize: "14px",
          fontWeight: "bolder",
          lineHeight: "1"
        }}
        htmlFor={id}
      >
        {label}
      </label>
      <textarea
        name={id}
        value={value}
        onFocus={e => e.target.select()}
        style={{
          boxSizing: "border-box",
          fontFamily: "inherit",
          fontSize: "inherit",
          display: "block",
          width: "100%",
          padding: "8px",
          borderWidth: "1px",
          borderColor: "rgba(0, 0, 0, 0.25)",
          borderRadius: "2px"
        }}
        readOnly={readOnly}
      />
    </div>
  );
};

export default textarea;
